<template>
  <HeaderBackOfiice
    v-if="currentState"
    class="breadcrumbs-main"
  >
    <template
      v-slot:header-back
    >
      <v-icon
        v-if="currentState.showBackArrow"
        color="black"
        @click="goBack()"
      >
        arrow_back
      </v-icon>
    </template>
    <template v-slot:header-icon>
      <v-icon>
        {{ currentState.icon }}
      </v-icon>
    </template>
    <template v-slot:header-title>
      <span class="title breadcumbs-title">
        {{ action ? `${action} ${$t(currentState.name)}` : $t(currentState.name) }}
      </span>
    </template>
  </HeaderBackOfiice>
</template>

<script>
import HeaderBackOfiice from './HeaderBackOfiice';

export default {
  name: 'TheBreadcrumb',
  components: {
    HeaderBackOfiice,
  },
  props: {
    currentState: {
      type: Object,
      default: () => {},
      required: false,
    },
  },
  data() {
    return {
      action: this.$route.params.action,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumbs-main {
  .breadcumbs-title {
    text-transform: capitalize;
  }
}
</style>
